import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { LineChart, Line, XAxis, YAxis, Label, ResponsiveContainer } from 'recharts';
import Title from '../../DashboardScreen/part/Title';
import { MoulinetteLog } from '../../../models/moulinetteLog';
import { ChartObject } from '../../../models/chartObject';

export default function Chart(props: { datas: MoulinetteLog[] | null }) {
	const [allDatas] = useState<MoulinetteLog[] | null>(props.datas);
	const theme = useTheme();
	const [chartDatas, setChartDatas] = useState<ChartObject[]>([]);

	useEffect(() => {
		if (allDatas) {
			const datas: MoulinetteLog[] = [...allDatas].reverse();

			for (let element of datas) {
				// Créer un object "Date" sinon on n'auras pas accès aux fonctions getMonth ect
				const dateLog: Date = new Date(element.date);

				const myDay: string = `${dateLog.getDate()}/${dateLog.getMonth() + 1}`;
				// Chercher si un log à déjà été effectué sur le même jour
				// const data: ChartObject | undefined = chartDatas.find(({ day }) => day === myDay);

				chartDatas.push({ day: myDay, number: element.bulls.length });
			}
			setChartDatas(chartDatas);
		}
	}, [allDatas, chartDatas]);

	return (
		<React.Fragment>
			<Title>Nombre de taureaux non indexés</Title>
			<ResponsiveContainer>
				<LineChart
					data={chartDatas}
					margin={{
						top: 16,
						right: 16,
						bottom: 0,
						left: 24,
					}}
				>
					<XAxis dataKey="day" stroke={theme.palette.text.secondary} style={theme.typography.body2} />
					<YAxis stroke={theme.palette.text.secondary} style={theme.typography.body2}>
						<Label
							angle={270}
							position="left"
							style={{
								textAnchor: 'middle',
								fill: theme.palette.text.primary,
								...theme.typography.body1,
							}}
						>
							Erreurs
						</Label>
					</YAxis>
					<Line isAnimationActive={true} type="monotone" dataKey="number" stroke={theme.palette.primary.main} dot={false} />
				</LineChart>
			</ResponsiveContainer>
		</React.Fragment>
	);
}
